import moment from 'moment'

import EyeIcon from '../../../components/ReusableComponents/Icons/Eye'
import { Cell, Row } from '../../../components/ReusableComponents/Table'
import { unescapeRegex } from '../../../utils/common'
import { EventsCell } from './EventsCell/index'
import styles from './Row.module.scss'

const TextCell = ({ children, ...props }) => (
  <Cell className={styles.textCell} {...props}>
    {children}
  </Cell>
)

const PreviewCell = ({ handleClick, disabled, ...props }) => (
  <Cell {...props} className={styles.previewCell}>
    <button disabled={disabled} onClick={handleClick}>
      <EyeIcon />
    </button>
  </Cell>
)

const EmailRow = ({
  to,
  subject,
  bodyInHtml,
  bodyInText,
  sentOn,
  events,
  id,
  handleSetViewId
}) => (
  <Row>
    <TextCell>{to}</TextCell>
    <TextCell>{moment(sentOn).format('MMM DD, hh:mm A')}</TextCell>
    <TextCell>
      <strong>{unescapeRegex(subject)}</strong>
    </TextCell>
    <EventsCell events={events} />
    <PreviewCell
      handleClick={() => handleSetViewId(id)}
      //disabled={!(bodyInHtml && bodyInText)}
    />
  </Row>
)

export default EmailRow
